import { apiGet, apiPut } from '../../../adapters/api-client/api';

export type AvailabilityBlockKind = 'RECURRING' | 'EXCEPTION';

/**
 * Mirrors the backend availability block shape
 * (backend/.../booking/domain/entities/availability.entity.ts).
 * A teacher's availability is a set of weekly RECURRING blocks plus optional
 * one-off EXCEPTION blocks. The frontend currently authors RECURRING blocks.
 */
export interface AvailabilityBlock {
  blockId?: string;
  kind: AvailabilityBlockKind;
  /** 0 = Sunday … 6 = Saturday (RECURRING) */
  dayOfWeek?: number;
  /** 'HH:mm' wall-clock in `timezone` */
  startTime?: string;
  endTime?: string;
  /** 'YYYY-MM-DD' (EXCEPTION) */
  date?: string;
  available?: boolean;
  /** IANA timezone, e.g. 'America/Mexico_City' */
  timezone: string;
}

export interface TeacherAvailability {
  teacherId: string;
  blocks: AvailabilityBlock[];
  updatedAt: string;
}

export function getMyAvailability(): Promise<{ availability: TeacherAvailability }> {
  return apiGet('/api/v1/teachers/me/availability');
}

export function replaceMyAvailability(
  blocks: AvailabilityBlock[],
): Promise<{ availability: TeacherAvailability }> {
  return apiPut('/api/v1/teachers/me/availability', { blocks });
}
